// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SoundTwoToneSvg from "@fishx/icons-svg/es/asn/SoundTwoTone";
import FishxIcon from '../components/FishxIcon';

var SoundTwoTone = function SoundTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: SoundTwoToneSvg
  }));
};

SoundTwoTone.displayName = 'SoundTwoTone';
export default React.forwardRef(SoundTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/SoundTwoTone.js
// module id = 4182
// module chunks = 0